import React, { Component } from 'react';
import {
  Row,
  Col,
  Card,
  Form, FormGroup, Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupButton,
  CardHeader,
  CardBody,
  CardFooter,
  CardGroup,
  Collapse, Button, Fade, Jumbotron,
  ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText,
  Table
} from 'reactstrap';

import $ from "jquery";
var JSONViewer = require('react-json-viewer');
import ReactJson from 'react-json-view'
const v = require('voca');
import { makeInput } from "common-import/custom";
import { MobXHelper, Request, VarHelper } from "common-import/helpers";
import { inject, observer } from "mobx-react";

const propertyProject = ["name", "description", "documents", "listImages", "listVideos", "projectType", "projectSubType", "workType", "address", "location", "village", "district", "city", "country", "minBudget", "maxBudget", "investmentType", "minConstructionArea", "maxConstructionArea", "minLandArea", "maxLandArea", "totalFloorArea", "minStartTime", "maxStartTime", "minFinishTime", "maxFinishTime", "numberOfLikes", "numberOfFollower", "status", "state", "createdAt", "updatedAt", "approved", "isHot", "stage", "isExperienceProject", "isVip", "createdByUser"];
let initialState = {};
propertyProject.forEach(val => initialState[val] = "");

@inject("projectStore", "userStore") @observer
class ProjectProfile extends Component {

  constructor(props) {
    super(props);
    this.state = {
      project: initialState,
      current: initialState,
    }
  }

  async componentDidMount() {
    await this.props.userStore.onReady();
    const { projectStore, match, languageStore } = this.props;
    this.setCurrentProject();
  }

  getProjectDetail = async () => {
    const { projectStore, match } = this.props;
    console.log('ID', match.params.id)
    projectStore.setCurrentProject(match.params.id);
    // let project = await projectStore.getProjectDetail(match.params.id);
    // this.setState({ project });
  }

  setCurrentProject = () => {
    const { projectStore, match } = this.props;
    let project = projectStore.setCurrentProject(match.params.id);
    console.log('__project__: ', project)
    let current = {};
    propertyProject.forEach(val => current[val] = project[val]);
    this.setState({ project, current });
  }

  approveProject = async e => {
    e.preventDefault();
    const { projectStore, match } = this.props;
    let continueApprove = confirm("Bạn có chắc chắn muốn xác thực nhà thầu này?");
    if(continueApprove) {
      // alert("Chức năng xác thực đang hoàn thiện");
      let result = await projectStore.approve({ id: match.params.id, approved: true });
      if (!!result.error) return window.toast.error("Có lỗi xảy ra, vui lòng thử lại   " + JSON.stringify(result.error));
      window.toast.info("Duyệt dự án thành công");
      // this.setState({ contractor: { ...this.state.contractor, approved: 1 } })
      projectStore.currentProject = {...projectStore.currentProject, approved: 1};
    }
  }

  renderApprove = () => {
    const { projectStore, match } = this.props;
    const { currentProject } = projectStore;
    const { approved } = currentProject;
    if (approved === undefined || approved === "" || approved === true || approved === 1) return null;
    return (
      <Row style={{ marginBottom: 30 }}>
        <Col xs="12" md="12" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
          <h3 style={{ marginRight: 10 }}>Dự án này chưa được duyệt.</h3>
          <Button style={{ display: "inline-block" }} type="submit" size="sm" color="primary" onClick={this.approveProject}><i className="fa fa-dot-circle-o"></i> Duyệt</Button>
        </Col>
      </Row>
    )
  }

  renderProjectForm = (form) => {
    if (!form || !form.id) {
      return;
    }
    console.log('__current__: ', this.state.current)
    return (
      <Form action="" method="post" onSubmit={e => e.preventDefault()}>
        {
          propertyProject.map((property, index) => {
            return (
              <FormGroup key={"property" + index}>
                <Label htmlFor={"nf-" + property}>{v.capitalize(property)}:</Label>
                {/* {makeInput(this, property)(<Input type="text" id={"nf-" + property} name={"nf-" + property} />)} */}
                <Input
                  type="text"
                  id={"nf-" + property}
                  name={"nf-" + property}
                  value={this.state.current[property]}
                  onChange={e => this.setState({
                    current: { ...this.state.current, [property]: e.target.value }
                  })}
                />
              </FormGroup>
            );
          })
        }
      </Form>
    )
  }

  renderUserForm = (user) => {
    if (user) {
      return (
        <Card>
          <CardHeader>
            <i className="fa fa-user" aria-hidden="true"></i> Creator
          </CardHeader>
          <CardBody>
            <div className="user-profile">
              <div className="user-profile__avatar">
                <img src={user.avatar} alt=""/>
              </div>
              <h5 className="user-profile__name">{user.name}</h5>
              <p className="user-profile__phone"><i className="fa fa-phone-square" aria-hidden="true"></i> {user.phone}</p>
              <p className="user-profile__email"><i className="fa fa-envelope" aria-hidden="true"></i> {user.email}</p>
            </div>
          </CardBody>
        </Card>
      )
    }
  }

  render() {
    const { projectStore, match } = this.props;
    const { currentProject } = projectStore;
    const projectId = this.props.match.params.id;
    return (
      <div className="animated fadeIn">
        {this.renderApprove()}
        <Row>
          <Col xs="12" md="12">
            <Card>
              <CardHeader>
                <i className="fa fa-envelope-open"></i>Thông tin của dự án: <strong>{currentProject.name}</strong>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col xs="12" md="8">
                    {this.renderProjectForm(currentProject)}
                  </Col>
                  <Col xs="12" md="4">
                    {this.renderUserForm(currentProject.createdByUser)}
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <Button type="submit" size="sm" color="primary" onClick={this.editProfile}><i className="fa fa-dot-circle-o"></i> Save</Button>
                <Button type="reset" size="sm" color="danger"><i className="fa fa-ban"></i> Cancel</Button>
              </CardFooter>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col xs="12" md="12" >
            {/* <div style={{overflowX:'auto'}}>
              <JSONViewer json={currentProject} />
            </div> */}
            <ReactJson
              src={currentProject}
              name={currentProject.name}
              displayDataTypes={false}
              theme={"ocean"}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

export default ProjectProfile;



// WEBPACK FOOTER //
// ./src/views/Projects/ProjectDetail.js